const styleSheet = () => ({
  bodyBackground: {
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.15)',
  },
  checkBoxHolder: {
    display: 'inline-block',
    marginRight: '16px',
    position: 'relative',
    zIndex: 1,
    top: '3px',
  },
  firstCell: {
    textAlign: 'left',
    paddingLeft: '14px',
    // position: "relative",
    wordBreak: 'break-all',
  },
  container: {
    position: 'relative',
  },
  noResults: {
    height: '61px',
    backgroundColor: '#fff',
    color: '#051D39',
    fontSize: '14px',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styleSheet;
